import { type IAppBanner, LanguageCode } from '@/interfaces';
import { getMasterTranslationLanguageCode, languageFieldsMapping } from '@/utils';
import callContentful from './base.fetchers';

type GetAppBanner = (args: {
  isPreviewMode: boolean;
  languageCode?: LanguageCode;
  slug: string;
}) => Promise<IAppBanner[]>;

export const getAppBanner: GetAppBanner = async ({ isPreviewMode, languageCode = LanguageCode.English, slug }) => {
  const mappedLanguageFields = languageFieldsMapping(languageCode);
  const languageField = getMasterTranslationLanguageCode(languageCode);

  const query = `
    {
      appBannerCollection(
        preview: ${isPreviewMode}
        locale: "${mappedLanguageFields.locale}"
        limit: 10
      ) {
        items {
          mainText {
            ${languageField}
          }
          subText {
            ${languageField}
          }
          buttonText {
            ${languageField}
          }
          appIcon {
            url
          }
          buttonLinkIos
          buttonLinkAndroid
          pageSlugs
          country
        }
      }
    }
  `;

  const response = await callContentful(query, isPreviewMode, slug, 'appBanner.fetchers.getAppBanner');

  const rawData = response?.data?.appBannerCollection?.items?.filter(Boolean) || [];

  // Transform the linked multiLanguageField data to flat string values
  const appBannerData = rawData.map((item: Record<string, unknown>) => {
    const mainText = item.mainText as Record<string, string> | null;
    const subText = item.subText as Record<string, string> | null;
    const buttonText = item.buttonText as Record<string, string> | null;

    return {
      ...item,
      mainText: mainText?.[languageField] || '',
      subText: subText?.[languageField] || '',
      buttonText: buttonText?.[languageField] || '',
    };
  });

  return appBannerData;
};
